import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { ResultOperation, Column, SelfTableList, FilterState, ListFields, usePermission, useTranslation } from '@np/np_webcomponentlib'
import { API_BUSINESS, API_OPERATIONS } from '../../shared/consts/api'

import { DataEntityType, initEntity, columnsIdrfspecification, columnsIdrfcharacteristictype, DataEntityTypeViewModel,  DisplayStatusDoc, columnsForChoise, DisplayTypeOperation, TypeCurrencyEnum } from './OperationBalanceTypes'

import { OperationBalanceForm } from './OperationBalanceForm'

import { ColumnEvent, ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'

import '../../shared/entityOperations/EntityOperations.css'
import { formatAmount4 } from '../../shared/utils/formatAmount4';




const OperationBalanceList = ({ listFilterFieldProps, title }: { listFilterFieldProps: ListFields[], title: string }) => {

  const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('SpecificationcharacteristictypeList');

  const initialFilter: FilterState = {
    listFields: listFilterFieldProps,
    sort: null,
    searchData: '',
    take: 50,
    skip: 0,
  }

  const [idEdit, setIDEdit] = useState<string>("")

  const [forceUpdate, setForceUpdate] = useState<boolean>(false)

  const [show2, setShow2] = useState(false);
  const xtralargemodalClose = () => { setIDEdit(""); setShow2(false) };
  const xtralargemodalShow = () => setShow2(true);


  const dateAddedTitle = useTranslation('dateAdded');
  const dateUpdatedTitle = useTranslation('dateUpdated');

  const idrfSpecificationTitle = useTranslation('idrfSpecification');
  const idrfCharacteristicTypeTitle = useTranslation('idrfCharacteristicType');
  const isMandatoryTitle = useTranslation('isMandatory');




  const memoizedColumnsSpecificationcharacteristictype = useCallback(() => {
    const columnsSpecificationcharacteristictype: Column[] = [


    {
      title: 'ID',
      listFields: {
        fieldName: 'idUnique',
        comparison: 'containsStrong',
        listVal: [''],
      },
      
      
      type: 'custom',
      custom: (data: DataEntityType) => (
        <>
        <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
        {data.idUnique}
        </>
      ),
      key: 51,
      withFilter: "all",
      class: "eventColumn"
    },



    {
      title: dateAddedTitle,
      listFields: {
        fieldName: 'dateAdded',
        comparison: 'containsStrong',
        listVal: [''],
      },
      type: 'date-time',
      key: 100,
      withFilter: 'onlySorted',
      class: "dateTtimeColumn"
    },


    {
      title: "Мерчант",
      listFields: {
        fieldName: 'idBusiness',
        comparison: 'equalsStrong',
        listVal: [''],
      },
      type: 'custom',
      custom: (data: DataEntityType) => <>{data.businessAsProduct?.name}</>,
      key: 8,
      withFilter: 'choose',

      filterChooseProps: {
        getDisplayDescription: (selectedData: any) => {
          return selectedData ? selectedData.name : ''
        },
        apiUrl: `${API_BUSINESS}business/list`,
        columns: columnsIdrfcharacteristictype,
        children: 'Поиск...',
      },
  },



      {
        title: "Тип операции",
        listFields: {
            fieldName: 'typeOperation',
            comparison: 'containsIgnoreCase',
            listVal: [''],
        },
        key: 17,
        type: 'custom',
            custom: (data: DataEntityType) => <><DisplayTypeOperation typeOperationData={data.typeOperation}></DisplayTypeOperation></>,
        withFilter: 'all',
    },
    
  


      {
        title: "Статус",
        listFields: {
            fieldName: 'status',
            comparison: 'containsIgnoreCase',
            listVal: [''],
        },
        key: 7,
        type: 'custom',
            custom: (data: DataEntityType) => <><DisplayStatusDoc statusDoc={data.status.toString()}></DisplayStatusDoc></>,
        withFilter: 'all',
    },
    
    {
      title: "Сумма",
      listFields: {
          fieldName: 'amount',
          comparison: 'containsIgnoreCase',
          listVal: [''],
      },
      type: 'custom',
      custom: (data: DataEntityType) => {
        return <>{formatAmount4(data?.amountInCurrencyBalance)}</>;},
      key: 29,
      withFilter: 'all',
  },

  {
      title: "Сумма руб",
      listFields: {
          fieldName: 'amount',
          comparison: 'containsIgnoreCase',
          listVal: [''],
      },
      type: 'custom',
      custom: (data: DataEntityType) => <>{formatAmount4(data?.amount)}</>,
      key: 27,
      withFilter: 'all',
  },

  {
    title: "Курс",
    listFields: {
        fieldName: 'amount',
        comparison: 'containsIgnoreCase',
        listVal: [''],
    },
    type: 'custom',
    custom: (data: DataEntityType) => <>{formatAmount4(data?.exchangeRate)}</>,
    key: 55,
    withFilter: 'all',
},


    {
      title: "Основание",
      listFields: {
          fieldName: 'basis',
          comparison: 'containsIgnoreCase',
          listVal: [''],
      },
      key: 18,
      withFilter: 'all',
  },

  {
    title: "Валюта",
    listFields: {
        fieldName: 'currency',
        comparison: 'containsIgnoreCase',
        listVal: [''],
    },
    key: 19,
    withFilter: 'all',
},
  


        {
          title: dateUpdatedTitle,
          listFields: {
            fieldName: 'dateUpdated',
            comparison: 'containsStrong',
            listVal: [''],
          },
          type: 'date-time',
          key: 101,
          withFilter: 'onlySorted',
          class: "dateTtimeColumn"
        }
    ]
  

    // if (debugMode || canRemove) {
    //   columnsSpecificationcharacteristictype.push(
    //     {
    //       title: '',
    //       listFields: null,
    //       type: 'custom',
    //       custom: (data: DataEntityType) => (

    //         <DeleteEntity idUnique={data.idUnique} apiPath={`${API_PRODUCT}/catalogproduct`} onResult={onResultRemove}></DeleteEntity>
    //       ),
    //       key: 102,
    //       withFilter: null,
    //       class: "eventColumn"
    //     })
    // }
    return columnsSpecificationcharacteristictype
  }, [idrfSpecificationTitle, idrfCharacteristicTypeTitle, isMandatoryTitle, dateAddedTitle, dateUpdatedTitle, debugMode, canRemove])


  const handleEdit = (idUnigue: string) => {
    setIDEdit(idUnigue)
  }

  const onResultRemove = (result: ResultOperation) => {
    if (result.status === "success") {

      setForceUpdate(true)

      console.log("forceUpdate:", forceUpdate)
    }
  }

  useEffect(() => {
    if (forceUpdate) {
      setForceUpdate(false)
    }
  }, [forceUpdate])


  useEffect(() => {
    if (idEdit !== "") {
      xtralargemodalShow()
    }
  }, [idEdit])

  const getTitleModal = () => {
    if (idEdit === "")
      return "Создание"
    else
      return "Редактирование"
  }



  const docClientForm = useMemo(() => (
    <OperationBalanceForm 
      title={getTitleModal()} 
      idInit={idEdit} 
      handleClose={xtralargemodalClose} 
      initEntityProps={listFilterFieldProps.length > 0 ? { ...initEntity, idClient: listFilterFieldProps[0].listVal[0] } : initEntity}
    />
  ), [show2]);

  return (
    <Fragment>

      <h2>{title}</h2>

      {canCreate &&
        <Button variant="primary" onClick={xtralargemodalShow}><i className='fa fa-plus'></i>
        </Button>
      }

      <Modal size="xl" show={show2} onHide={xtralargemodalClose}>
        <ModalHeader>
          <ModalTitle as="h5"></ModalTitle>
          <span className="d-flex ms-auto" onClick={xtralargemodalClose}><i className='fe fe-x ms-auto' ></i></span>
        </ModalHeader>
        <ModalBody>
          {/* <DocClientForm title={getTitleModal()} idInit={idEdit} handleClose={xtralargemodalClose} initEntityProps={listFilterFieldProps.length > 0 ? { ...initEntity, idClient: listFilterFieldProps[0].listVal[0] } : initEntity}></DocClientForm> */}
          {docClientForm}
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={xtralargemodalClose}>
            Закрыть
          </Button>
        </ModalFooter>
      </Modal>

      


      {!show2 && listFilterFieldProps.length > 0 && <SelfTableList apiUrl={`${API_OPERATIONS}balance/list`} columns={memoizedColumnsSpecificationcharacteristictype()} classProp='table table-striped' theadClassProp='table' forceUpdate={forceUpdate} initialFilterState={initialFilter} />}
      {!show2 && listFilterFieldProps.length == 0 && <SelfTableList apiUrl={`${API_OPERATIONS}balance/list`} columns={memoizedColumnsSpecificationcharacteristictype()} classProp='table table-striped' theadClassProp='table' forceUpdate={forceUpdate} />}
    </Fragment>
  )
}


export default OperationBalanceList